import { useGetAiAccessControls } from '../../aiControl/aiAccessQueries';
import { useDisplayInteractiveEducation } from '../hooks/hooks';
import { useUserIndustry } from '../hooks/useUserIndustry';
export const useInteractiveEducation = ({
  videoId,
  hasCaptions = true,
  interactiveContentTrackingProps
}) => {
  const {
    aiAccessControls
  } = useGetAiAccessControls();
  const aiEnabled = !!(aiAccessControls !== null && aiAccessControls !== void 0 && aiAccessControls.generativeAiEnabled);
  const interactiveEducationEnabled = aiEnabled && hasCaptions;
  const {
    displayInteractiveEducation,
    handleDisplayInteractiveEducation
  } = useDisplayInteractiveEducation(interactiveContentTrackingProps, videoId);
  useUserIndustry();
  return {
    displayInteractiveEducation,
    handleDisplayInteractiveEducation,
    interactiveEducationEnabled
  };
};